import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_ACCOUNT } from 'src/hooks/accounts/get-current-account.hook';

export const AVATAR_UPLOAD = gql`
  mutation ($avatar: Upload) {
    uploadProfileAvatar(avatar: $avatar) {
      avatarUrl
    }
  }
`;

export const useUploadProfileAvatar = () => {
  const [uploadAvatar] = useMutation(AVATAR_UPLOAD, {
    refetchQueries: [GET_CURRENT_ACCOUNT],
  });

  return uploadAvatar;
};
